import { FC } from 'react'
import { FileCsv } from '@emotion-icons/fa-solid/FileCsv'
import { FileUpload } from 'src/components/file-upload'
import { Divider, Typography } from '@mui/material'
import styled from '@emotion/styled'
import { useRecoilState, useSetRecoilState } from 'recoil'
import * as atoms from 'src/atoms/user-lists/user-lists-modal'
import Link from 'next/link'
import { Colors } from 'src/components/theme'
import { json2csv } from 'json-2-csv'
import { downloadContent } from 'src/utils/csv'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const InfoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const ArticleLink = styled(Link)`
  color: ${Colors.blueDark};

  :hover {
    opacity: 0.8;
  }
`
const DownloadText = styled(Typography)`
  color: ${Colors.blueDark};
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`

const Actions = styled.div`
  display: flex;
  gap: 4px;
`

const TEMPLATE_ROWS = [
  {
    address: '5355 Interregional Hwy, Austin, TX 78723, USA',
  },
  {
    address: '5621 N Interstate Hwy 35, Austin, TX 78723, USA',
  },
  {
    address: '1911 Aldrich St #120, Austin, TX 78723, USA',
  },
  {
    address: '3851 Airport Blvd, Austin, TX 78722, USA',
  },
]
const ARTICLE_URL = 'https://intercom.help/alphamap/en/articles/9270073-new-upload-custom-lists-csv-files'

export const CsvUploadContent: FC = () => {
  const setUploadSection = useSetRecoilState(atoms.uploadSection)
  const [file, setFile] = useRecoilState(atoms.csvFile)

  const handleChange = (f: File | undefined) => {
    setFile(f)
    if (f) {
      setUploadSection('match-data')
    }
  }

  const onClicDownloadTemplate = () => {
    const csv = json2csv(TEMPLATE_ROWS, {
      keys: ['address'],
    })
    downloadContent(csv, 'AlphaMap List Upload Template.csv')
  }

  return (
    <Container>
      <FileUpload
        value={file}
        onChange={handleChange}
        accept=".csv"
        uploadText="Drag a CSV file here or"
        uploadButtonText="Upload CSV File"
        icon={FileCsv}
      />
      <Divider />
      <InfoWrapper>
        <Typography>Uploading for the first time?</Typography>
        <Actions>
          <ArticleLink href={ARTICLE_URL} target="_blank">
            Review article
          </ArticleLink>
          <Typography>or</Typography>
          <DownloadText onClick={onClicDownloadTemplate}>Download template</DownloadText>
        </Actions>
      </InfoWrapper>
    </Container>
  )
}
